class PressBanner {
  constructor () {
    this.mainSlider = null;
    this.thumbsSlider = null;
    this.headerHeight = null;
    this.autoPlay = false;
    this.autoplay = {};
    this.initSliders();
  }

  initSliders () {
    this.initThumbsSlider();
    this.scrollVideo();
  }

  scrollVideo () {
    this.headerHeight = document.querySelector("header.header").clientHeight;

    document.addEventListener("scroll", () => {
      if (this.mainSlider) this.checkIsVisible();
    });
  }

  checkIsVisible () {
    const elementRect = document.querySelector(".press-banner");
    const rect = elementRect.getBoundingClientRect();
    const isVisible = (rect.top - this.headerHeight < 0) && (rect.bottom - this.headerHeight > 0);


    if (isVisible && !this.autoPlay) {
      // console.log("turn on");
      this.autoPlay = true;
      this.thumbsSlider.autoplay.resume();
      this.thumbsSlider.autoplay.start();
    }
    if (!isVisible && this.autoPlay) {
      // console.log("turn off");
      this.thumbsSlider.autoplay.pause();
      this.autoPlay = false;
    }
  }

  initThumbsSlider () {
    const _this = this;
    this.thumbsSlider = new Swiper(".js-press-thumbs", {
      slidesPerView: "auto",
      // loop:true,
      autoplay: {
        delay: 5000
      },
      centeredSlides: true,
      slideToClickedSlide: true,
      slideThumbActiveClass: "swiper-slide-active",
      on: {
        slideChange (swiperSlides) {
          _this.mainSlider?.slideTo(swiperSlides.activeIndex);
        }
      }
    });
    this.initMainSlider();
  }

  initMainSlider () {
    const _this = this;
    this.mainSlider = new Swiper(".js-press-slider", {
      slidesPerView: 1,
      autoHeight: true,
      effect: "fade",
      slideActiveClass: "swiper-slide-active",
      on: {
        slideChange (swiperSlides) {
          _this.thumbsSlider.slideTo(swiperSlides.activeIndex);
        }
      },
      navigation: {
        nextEl: ".press-button-next",
        prevEl: ".press-button-prev"
      },
      pagination: {
        el: document.querySelector(".js-press-banner-bullets"),
        type: "bullets",
        clickable: true,
        autoHeight: true,
        bulletActiveClass: "press-bullets--active",
        bulletClass: "press-bullets__item",
        renderBullet: function (index, className) {
          return "<span class=\"" + className + "\" ><span class=\"press-bullets__dot\">" + "</span></span>";
        }
      }
    });

  }

  static initHandlers () {
    document.addEventListener("DOMContentLoaded", () => {
      setTimeout(() => {
        new PressBanner();
      }, 0);
    });
  }
}

PressBanner.initHandlers();
